import { Container, Grid, Typography, Button, Stack, Box, ButtonBase } from "@mui/material";
import AppleIcon from "@mui/icons-material/Apple";
import AndroidIcon from "@mui/icons-material/Android";

export default function DownloadApps() {
  return (
    <Container
      maxWidth={false}
      sx={{
        background: (theme) => theme.palette.secondary.main,
        color: "white",
        textAlign: "center",
        py:{xs:4,md:4}
      }}
    >
      <Grid container spacing={6} alignItems="center" justifyContent="center">
        {/* Left Side - Text */}
        <Grid item xs={12} md={6}>
          <Typography variant="h3" fontWeight="bold" gutterBottom>
            Lleva tu salud en tu bolsillo 📲
          </Typography>
          <Typography variant="h6" color="rgba(255,255,255,0.85)" sx={{ mb: 4 }}>
            Descarga <strong>CardexMedico</strong> y administra tu historial
            médico desde cualquier lugar. Disponible para iOS y Android.
          </Typography>

          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={2}
            justifyContent="center"
            alignItems="center"
          >
            <ButtonBase
            href="https://apps.apple.com/" // Replace with your real link
            target="_blank"
            sx={{
                borderRadius: 2,
                overflow: "hidden",
                display: "inline-block",
            }}
            >
            <Box
                component="img"
                src="https://firebasestorage.googleapis.com/v0/b/xpediente-clinico.appspot.com/o/web%2FDownload_on_the_App_Store_Badge_ESMX_RGB_blk_100217.svg?alt=media&token=453cb21b-672d-4e17-89a0-d71f4e0e17eb"
                alt="Download on the App Store"
                sx={{ height: 48 }}
            />
            </ButtonBase>

            <ButtonBase
            href="https://play.google.com/store" // Replace with your real link
            target="_blank"
            sx={{
                borderRadius: 2,
                overflow: "hidden",
                display: "inline-block",
            }}
            >
            <Box
                component="img"
                src="https://firebasestorage.googleapis.com/v0/b/xpediente-clinico.appspot.com/o/web%2FGetItOnGooglePlay_Badge_Web_color_Spanish-LATAM.png?alt=media&token=cfc7b9bb-ccbb-48d4-ba74-d5bdb594fe98"
                alt="Download on the Google Play"
                sx={{ height: 48 }}
            />
            </ButtonBase>
          </Stack>
        </Grid>

        {/* Right Side - Phone Mockup */}
        <Grid item xs={12} md={6}>
          <Box
            component="img"
            src="https://firebasestorage.googleapis.com/v0/b/xpediente-clinico.appspot.com/o/web%2Fcardemedicocellphones.png?alt=media&token=097d4a1e-c8cc-436a-83f6-d92c7ec2d0af" // Replace with your mockup image
            alt="CardexMedico App"
            sx={{
              width: "400px",
              heigh: "200px",
              my:0,
              mx: "auto",
            }}
          />
        </Grid>
      </Grid>
    </Container>
  );
}
